define.alias("shared/components/shared/post/secondary/wrapper", "settings/components/shared/post/secondary/wrapper");